import React, { useState } from "react";
import VideoBox from "./VideoBox";
import { addDoc, collection } from "firebase/firestore";

function Rating({
  loading,
  rightVideo,
  leftVideo,
  db,
  updateEloRatings,
  fetchFilteredVideos,
  dailyVoteStats,
}) {
  const [name, setName] = useState("");
  const [division, setDivision] = useState("M");
  const [year, setYear] = useState(2023);
  const [school, setSchool] = useState("");
  const [winner, setWinner] = useState(false);
  const [finalist, setFinalist] = useState(false);
  const [videoId, setVideoId] = useState("");
  const [award, setAward] = useState("Callahan");
  const [showForm, setShowForm] = useState(false);
  const saveNominee = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "videos"), {
        name: name,
        division: division,
        award: award,
        year: parseInt(year),
        school: school,
        winner: winner,
        finalist: finalist,
        numVotesFor: 0,
        numVotesAgainst: 0,
        videoId: videoId,
        elo: 1000,
      });

      setName("");
      setSchool("");
      setWinner(false);
      setFinalist(false);
      setVideoId("");
    } catch (e) {
      console.error(`Error saving nominee: ${e.message}`);
    }
  };

  return (
    <>
      {loading ? (
        <div className="loading">Loading videos from database...</div>
      ) : (
        <div className="video-container">
          <VideoBox
            video={leftVideo}
            handleVote={() => updateEloRatings(leftVideo.id, rightVideo.id, db)}
          />
          <VideoBox
            video={rightVideo}
            handleVote={() => updateEloRatings(rightVideo.id, leftVideo.id, db)}
          />
        </div>
      )}
      <button className="vote-button" onClick={fetchFilteredVideos}>
        Skip
      </button>
      <div className="admin-section">
        <button
          className="toggle-form-button"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? "Hide Admin Form" : "Add New Nominee"}
        </button>

        <div className="vote-stats-section" style={{marginBottom: '20px'}}>
          <h3>Daily Vote Statistics</h3>
          {dailyVoteStats && dailyVoteStats.length > 0 ? (
            <div className="vote-stats-container" style={{maxHeight: '300px', overflowY: 'auto', border: '1px solid #ccc', padding: '10px', borderRadius: '5px'}}>
              {dailyVoteStats.map((stat, index) => (
                <div key={stat.id} style={{display: 'flex', justifyContent: 'space-between', padding: '5px 0', borderBottom: index < dailyVoteStats.length - 1 ? '1px solid #eee' : 'none'}}>
                  <span>{stat.date}</span>
                  <span>{stat.count} votes</span>
                </div>
              ))}
            </div>
          ) : (
            <p>No vote data available yet.</p>
          )}
        </div>

        {showForm && (
          <div className="admin-form-container">
            <h2>Add New Callahan Nominee</h2>
            <form onSubmit={saveNominee}>
              <div className="form-group">
                <label>Name:</label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label>Division:</label>
                <select
                  value={division}
                  onChange={(e) => setDivision(e.target.value)}
                >
                  <option value="M">Men's</option>
                  <option value="W">Women's</option>
                </select>
              </div>

              <div className="form-group">
                <label>Award:</label>
                <select
                  value={award}
                  onChange={(e) => setAward(e.target.value)}
                >
                  <option value="Callahan">Callahan</option>
                  <option value="Donovan">Donovan</option>
                </select>
              </div>

              <div className="form-group">
                <label>Year:</label>
                <input
                  type="number"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label>School:</label>
                <input
                  type="text"
                  value={school}
                  onChange={(e) => setSchool(e.target.value)}
                  required
                />
              </div>

              <div className="form-group checkbox-group">
                <label>
                  <input
                    type="checkbox"
                    checked={winner}
                    onChange={(e) => setWinner(e.target.checked)}
                  />
                  Winner
                </label>

                <label>
                  <input
                    type="checkbox"
                    checked={finalist}
                    onChange={(e) => setFinalist(e.target.checked)}
                  />
                  Finalist
                </label>
              </div>

              <div className="form-group">
                <label>YouTube Video ID:</label>
                <input
                  type="text"
                  value={videoId}
                  onChange={(e) => setVideoId(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="save-button">
                Save to Database
              </button>
            </form>
          </div>
        )}
      </div>
    </>
  );
}

export default Rating;
